import dayjs from "dayjs";
import { MaterialDetailFormValuesPaginated } from "features/loading-log/component/Top-bar/type";
import { MaterialLoadingLogTable } from "features/material-details/compoents/table/material-Item";
import { MatrialDetailsViewTopBar } from "features/material-details/compoents/Top-bar/material-top-bar";
import { useGetMaterialDetailList } from "features/material-details/use-cases/get-getLoading"
import { usePaginationParams } from "hooks";
import { omit } from "lodash";
import { useState } from "react";
import { formatDate } from "utils/date";
export const MaterialView = () => {
    const getInitialFilterValues: any = {
        MaterialName: undefined,
        Description:undefined,
        MaterialType:undefined
    };

    const [matrialEditData, setmatrialEditData] = useState<any>(undefined);
    const [showAppUserModal, setShowAppUserModal] = useState(false);
    const { params, updateParams, resetPage } =
        usePaginationParams<MaterialDetailFormValuesPaginated>({
            page: 1,
            size: 10,
            ...getInitialFilterValues,
        });
    const preparePayload = (params1: any) => {
        const createdAtFrom = params1.date?.[0];
        const createdAtTo = params1.date?.[1];

        return {
            ...omit(params1, ['date']),
            created_at_from: createdAtFrom
                ? formatDate({
                    date: dayjs(createdAtFrom).startOf('day'),
                    format: 'dbDate',
                })
                : undefined,
            created_at_to: createdAtTo
                ? formatDate({
                    date: dayjs(createdAtTo).endOf('day'),
                    format: 'dbDate',
                })
                : undefined,
        };
    };

      const getLoadingListQueryResponse: any = useGetMaterialDetailList(preparePayload(params), {
        retry: false,
    });
    
    

    const handleFiltersChange = (values: MaterialDetailFormValuesPaginated) => {  
       
        const filterValues: MaterialDetailFormValuesPaginated = values
        ? values
        : getInitialFilterValues;
        
        updateParams(filterValues);
        resetPage();
    };

  
return (
        <>
            <MatrialDetailsViewTopBar
                getInitialFilterValues={getInitialFilterValues as any}
                handleFilter={handleFiltersChange}
                matrialEditData={matrialEditData}
                showAppUserModal={showAppUserModal}
                setShowAppUserModal={setShowAppUserModal}
                setmatrialEditData={setmatrialEditData}
                onRefresh={getLoadingListQueryResponse.refetch}
            />
            <MaterialLoadingLogTable
                isListLoading={
                    getLoadingListQueryResponse.isFetching
                }
                vehicleList={getLoadingListQueryResponse?.data?.res?.items}
                itemsCount={getLoadingListQueryResponse?.data?.totalRecords || 0}
                tableParams={params as any}
                updateParams={updateParams}
                setmatrialEditData={setmatrialEditData}
                setShowAppUserModal={setShowAppUserModal}
                onApproveReject={'' as any}
                onRefresh={getLoadingListQueryResponse.refetch}
                isFetching={ getLoadingListQueryResponse.isFetching}

            />
        </>
    )
}